// Enumerations
import { CharactersEnum } from '@openbank/ziniaweb-ui-core-models';
// Constants
import { UPLOAD_ID_DIFFERENT_DATA_BIRTHDATE_ID } from './constants/upload-id-different-data.configuration.utils.constants';
// Types
import { UploadIdDifferentDataItemConfigurationUtilsType } from './types/upload-id-different-data.configuration.utils.type';

const isBirthDateFeature = (id: any): boolean => id === UPLOAD_ID_DIFFERENT_DATA_BIRTHDATE_ID;

const getResumeItemOrDefaultCharacter = ({
  customerData,
  id,
}: Pick<UploadIdDifferentDataItemConfigurationUtilsType, 'customerData' | 'id'>) =>
  customerData?.[id] || CharactersEnum.NO_VALUE;

const mapBirthDateLabelOrOther = ({
  customerData,
  formatDate,
  id,
}: UploadIdDifferentDataItemConfigurationUtilsType): string =>
  isBirthDateFeature(id)
    ? formatDate(customerData?.[id])
    : getResumeItemOrDefaultCharacter({ customerData, id });

export { mapBirthDateLabelOrOther };
